import { enqueueSnackbar } from '~/utils/notifications';
import { SKIP_REASONS, SkipReason, SkipReport } from './FileHandler';

const NAMES_TO_SHOW = 3;

function formatNames(names: string[]): string {
    if (names.length <= NAMES_TO_SHOW) {
        return names.join(', ');
    }
    const shown = names.slice(0, NAMES_TO_SHOW).join(', ');
    const extra = names.length - NAMES_TO_SHOW;
    return `${shown}, +${extra} more`;
}

const REASON_TEXT: Record<SkipReason, string> = {
    'unimportable-dicom': 'could not be imported as DICOM',
    'repeated-roi-number':
        'the structure set holds two structures under one ROI number',
};

/** One toast per reason a file was skipped for, in a fixed order. */
export function emitSkipReportToasts(report: SkipReport): void {
    for (const reason of SKIP_REASONS) {
        const skips = report.skips.filter((skip) => skip.reason === reason);
        if (skips.length === 0) {
            continue;
        }
        const summary =
            `${skips.length} of ${report.examined} files skipped: ` +
            REASON_TEXT[reason];
        // The user-facing toast lists filenames (PHI) so the user can locate
        // the skipped files; `logMessage` drops the names to keep the console
        // mirror in WarningSnackbarContent PHI-free.
        const names = formatNames(skips.map((skip) => skip.fileName));
        enqueueSnackbar(`${summary} (${names}).`, {
            variant: 'warning',
            logMessage: `${summary}.`,
        });
    }
}
